export const EVENT_NAMES = {
  ANALYTICS: 'analitics',
};
